import { Helmet } from "react-helmet-async"
import DueDiligenceView from "../../../components/dashboard/transitions/DueDiligence/DueDiligenceView";

export default function DueDiligence() {
  return <>
    <Helmet>
      <title> Due Diligence | Platform Solutions</title>
    </Helmet>
    <DueDiligenceView />
  </>
}